import { Deserializable } from '../deserializable.model';

export class PageResponse<T> implements Deserializable {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    query: string;
    items: T[];
    page: any;
    item: T;

    deserialize(input: any): this {
        var ret = Object.assign(this, input);

        return ret;
    }
}
